export default function getSearchString(code: string | undefined) {
  if (code === '7') {
    return '?cons=true';
  }

  return '';
}
